

























































































































































































































































import Vue from 'vue';
import UploadFromPCCreatives from '@/components/campaign/UploadFromPCCreatives.vue';
import Button from '@/components/form/Button.vue';
import FieldButton from '@/components/form/FieldButton.vue';
import FieldInput from '@/components/form/FieldInput.vue';
import { TCollectionIcons, typeTraffic } from '@/types';
import { Content, ContentImage } from '@/types/publisher/inventory';
import { TranslateResult } from 'vue-i18n';
import publisherIcons from './publisherIcons';
import { cloneDeep } from 'lodash';

const CACH_CONTENT: Content = {
  id: '',
  title: '',
  description: '',
  link: '',
  creative: {},
  img: null,
  isChoosedImage: false,
  isEdited: false,
};

export default Vue.extend({
  name: 'PlacementCustomContent',
  components: { UploadFromPCCreatives, FieldInput, Button, FieldButton },
  props: {
    placementId: {
      type: String,
      required: true,
      default: '',
    },
    placementType: {
      type: String,
      required: true,
    },
  },
  watch: {
    placementType() {
      this.resetPlacementContent();
    },
  },
  computed: {
    contents(): Array<Content> {
      return (
        this.$store.getters['publisher/getPlacementContentsById'](
          this.placementId
        ) || []
      );
    },
    publisherIcons(): TCollectionIcons {
      return publisherIcons;
    },
    typeIsNotBanner(): boolean {
      return this.placementType !== typeTraffic.BANNER;
    },
    typeIsPush(): boolean {
      return this.placementType === typeTraffic.PUSH;
    },
  },
  methods: {
    validationContent(): boolean {
      this.resetFormErrors();
      let succes = true;

      if (!this.cachContent.creative?.img) {
        this.setFormErrors('img', this.$t('errors.required'));
        succes = false;
      }

      if (this.placementType !== typeTraffic.BANNER) {
        if (!this.cachContent.title) {
          this.setFormErrors('title', this.$t('errors.required'));
          succes = false;
        }
      }

      if (!this.cachContent.link) {
        this.setFormErrors('link', this.$t('errors.required'));
        succes = false;
      }

      return succes;
    },
    addContent() {
      this.showContentAddButton = false;
      this.disabledContentAddButton = true;
    },
    saveContent() {
      if (this.validationContent()) {
        const newContent: Content = cloneDeep(this.cachContent);
        const payload = [this.placementId, newContent];
        this.$store.dispatch('publisher/addPlacementContentData', payload);
        this.resetPlacementContent();
      }
    },
    editContent(content: Content) {
      if (content) {
        this.cachContent = cloneDeep(content);
        this.disabledContentAddButton = true;
        this.showContentAddButton = true;
        content.isEdited = true;
      }
    },
    closeAddContent(): void {
      this.resetPlacementContent();
    },
    confirmEditedContent(content: Content) {
      if (this.validationContent()) {
        const newContent: Content = cloneDeep(this.cachContent);
        this.$store.dispatch(
          'publisher/updatePlacementContentData',
          newContent
        );
        content.isEdited = false;
        this.resetPlacementContent();
      }
    },
    chooseImage(image: ContentImage) {
      this.cachContent.creative = image[0];
      this.cachContent.isChoosedImage = true;
    },
    deleteContent(contentId: string): void {
      const payload = [this.placementId, contentId];

      this.$store.dispatch('publisher/deletePlacementContentData', payload);
      this.resetPlacementContent();
    },
    resetPlacementContent() {
      this.resetFormErrors();
      this.disabledContentAddButton = false;
      this.showContentAddButton = true;

      this.cachContent = { ...CACH_CONTENT };
    },
    setFormErrors(field: string, message: string | TranslateResult) {
      this.formErrors[field].push(message);
    },
    resetFormErrors(): void {
      this.formErrors.img = [];
      this.formErrors.title = [];
      this.formErrors.description = [];
      this.formErrors.link = [];
    },
  },
  data() {
    return {
      disabledContentAddButton: false,
      showContentAddButton: true,
      cachContent: { ...CACH_CONTENT },
      formErrors: {
        img: [],
        title: [],
        description: [],
        link: [],
      },
    };
  },
});
